// extracted by mini-css-extract-plugin
module.exports = {"container":"LedgerPath_container__3sICy","tip":"LedgerPath_tip__37Jo_","ledgerTip":"LedgerPath_ledgerTip__2R_pf"};